import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@fontsource/figtree/400.css'
import '@fontsource/figtree/500.css'
import '@fontsource/figtree/700.css'
import '@fontsource/figtree/800.css'
import '@fontsource/figtree/900.css'
import '@/scss/base.scss'

createApp(App)
  .use(router)
  .mount('#app')
